<template>
  <v-dialog
    max-width="800"
    :value="value"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="close(vehicle)"
  >
    <v-card tile v-if="value">
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="close(vehicle)">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title">{{
          value.selectedItem
            ? resx.labels.updateVehicle
            : resx.labels.newVehicle
        }}</span>
      </v-app-bar>
      <form @submit.prevent="save()" novalidate>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row wrap>
              <v-col cols="12" md="6">
                <v-select
                  data-vv-name="type"
                  :data-vv-as="resx.labels.type"
                  :error-messages="errors.collect('type')"
                  v-validate="'required'"
                  :items="vehicleTypes"
                  v-model="selectedItem.type"
                  :label="resx.labels.type"
                  item-text="name"
                  item-value="_id"
                  return-object
                  autocomplete
                  cache-items
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  data-vv-name="description"
                  :data-vv-as="resx.labels.description"
                  :label="resx.labels.description"
                  :error-messages="errors.collect('description')"
                  v-model="selectedItem.description"
                  v-validate="'required'"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  data-vv-name="uniqueIdentifier"
                  :data-vv-as="resx.labels.uniqueIdentifier"
                  :label="resx.labels.uniqueIdentifier"
                  :error-messages="errors.collect('uniqueIdentifier')"
                  v-model="selectedItem.uniqueIdentifier"
                  v-validate="
                    `required|uniqueid:${selectedItem._id},${selectedItem.contractorId}`
                  "
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <comments-component
                  :value="selectedItem.comments"
                  @input="selectedItem.comments = $event"
                  :label="commentsLabel"
                  mode="edit"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close(vehicle)">{{ resx.labels.cancel }}</v-btn>
          <v-btn class="primary" type="submit" :disabled="!isValidForm">{{
            resx.labels.ok
          }}</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import store from "@/store/store";
import vehicleService from "@/services/VehicleService";
import vehicleTypeService from "@/services/VehicleTypeService";
import { sprintf } from "sprintf-js";

import commentsComponent from "@/components/common/comments.vue";
import roles from "@/utils/roles";

const uniqueid = {
  getMessage() {
    return store.state.locale.resx.messages.uniqueVehicleIdentifier;
  },
  async validate(value, args) {
    const isValid = await vehicleService.isValidId(args[0], value, args[1]);
    return {
      valid: isValid ? isValid.result : false
    };
  }
};

export default {
  name: "edit-vehicle",
  async mounted() {
    this.$validator.extend("uniqueid", uniqueid);
    this.vehicleTypes = await vehicleTypeService.list();
  },
  components: {
    commentsComponent
  },
  computed: {
    // Los comentarios los ve la empresa contratista; el personal del sistema
    // lo tiene que saber al editarlos.
    commentsLabel() {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        this.$store.state.constants.roles.ALL_SYS_ROLES
      )
        ? this.resx.labels.comments_visible_to_company
        : this.resx.labels.comments;
    }
  },
  data() {
    return {
      vehiclesTypes: [],
      search: "",
      selectedItem: null,
      originalSelectedItem: null,
      vehicle: null
    };
  },
  methods: {
    async save() {
      let payload = Object.assign({}, this.selectedItem);
      if (!this.selectedItem._id) {
        this.$emit("save", { isNew: true, item: payload });
      } else {
        this.$emit("save", { isNew: false, item: payload });
      }
    },
    async close(vehicle) {
      if (JSON.stringify(this.originalSelectedItem) != JSON.stringify(this.selectedItem)) {
        await this.botConfirmDialog({
          title: `${this.resx.labels.updateVehicle}`,
          content: sprintf(
          this.resx.messages.noSavedChanges,
          vehicle.description
          )
        })
        this.$emit("close");
      } else {
        this.$emit("close");
      }
    }
  },
  props: ["value"],
  watch: {
    value(val) {
      this.selectedItem =
        val && val.selectedItem ? Object.assign({}, val.selectedItem) : {};
      this.originalSelectedItem = Object.assign({}, this.selectedItem);
    }
  }
};
</script>
